import type { VizType } from '../../../data/notationHotspots';
import { EdgeObjectSimplifier } from './EdgeObjectSimplifier';
import { WaveformToWord } from './WaveformToWord';
import { MemorySpikeTimeline } from './MemorySpikeTimeline';
import { StateGaugeCluster } from './StateGaugeCluster';
import { StabilityField } from './StabilityField';
import { PredictionVsInput } from './PredictionVsInput';
import { UrgencyAmplifier } from './UrgencyAmplifier';
import { ValenceMapper } from './ValenceMapper';
import { StoryArcBuilder } from './StoryArcBuilder';
import { ReinforcementLoop } from './ReinforcementLoop';
import { AttentionSpotlight } from './AttentionSpotlight';
import { AttentionFlowSankey } from './AttentionFlowSankey';
import { TimeLedger } from './TimeLedger';
import { ProxyVsReality } from './ProxyVsReality';
import { ProcedureCollapse } from './ProcedureCollapse';
import { RankLadder } from './RankLadder';
import { DetailLossFunnel } from './DetailLossFunnel';
import { NarrativeLens } from './NarrativeLens';
import './vizzes.css';

interface VizRouterProps {
  type: VizType;
  props?: Record<string, unknown>;
}

export function VizRouter({ type }: VizRouterProps) {
  switch (type) {
    case 'edge-simplifier': return <EdgeObjectSimplifier />;
    case 'waveform-word': return <WaveformToWord />;
    case 'memory-spike': return <MemorySpikeTimeline />;
    case 'state-gauge': return <StateGaugeCluster />;
    case 'stability-field': return <StabilityField />;
    case 'prediction-input': return <PredictionVsInput />;
    case 'urgency-amplifier': return <UrgencyAmplifier />;
    case 'valence-mapper': return <ValenceMapper />;
    case 'story-arc': return <StoryArcBuilder />;
    case 'reinforcement-loop': return <ReinforcementLoop />;
    case 'attention-spotlight': return <AttentionSpotlight />;
    case 'attention-sankey': return <AttentionFlowSankey />;
    case 'time-ledger': return <TimeLedger />;
    case 'proxy-reality': return <ProxyVsReality />;
    case 'procedure-collapse': return <ProcedureCollapse />;
    case 'rank-ladder': return <RankLadder />;
    case 'detail-funnel': return <DetailLossFunnel />;
    case 'narrative-lens': return <NarrativeLens />;
    default: return null;
  }
}
